import React from 'react';
import styles from './CheckboxesGroup.module.scss';
import IconCheckIn from '../../../assets/icons/foursquare-check-in.svg';

const CheckboxesGroup = (props) => {
  const { 
    filterOptions,
    fieldName,
    setFilter,
    selectedFilters
  } = props;
  
  const filterName = fieldName.replace('field-', '').replace('[]', '');

  const handleCheckboxChange = (e) => {
    const action = e.target.checked ? 'add' : 'remove';
    setFilter(filterName, e.target.value, action);
  };

  return (
    <ul className={styles.singleFilterList}>
      {
        filterOptions.map(option => {
          const isChecked = selectedFilters[filterName].indexOf(option.value) >= 0;

          return (
            <React.Fragment>
              <li>
                <label>
                  {option.label} ({option.moviesCount})

                  <input 
                    type="checkbox" 
                    name={fieldName}
                    value={option.value} 
                    onChange={handleCheckboxChange}
                    checked={isChecked}
                  />

                  <img src={IconCheckIn} className={styles.iconCheckIn} alt="" />
                </label>
              </li>
            </React.Fragment>
          );
        })
      }
    </ul>
  );
}

export { CheckboxesGroup }
